import { useState, useEffect } from "react";
import Head from "next/head";
import useUser from "../../../lib/useUser";
import withSession from "../../../lib/session";
import { Layout } from "../../../common/Layout";
import { Upload } from "../../../common/Upload";
import { Imgix } from "../../../common/UI";
import {
  Container,
  Grid,
  Typography,
  Table,
  TableContainer,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  Chip,
  Checkbox,
  TextField,
  FormControlLabel,
  CircularProgress,
} from "@mui/material";

import { QueryClient, QueryClientProvider, useQuery } from "react-query";
import { request, gql } from "graphql-request";

import Moment from "react-moment";
import moment from "moment";
import "moment-timezone";

import { sortBy, toString, get } from "lodash";
import { useDebounce } from "react-use";

export default function PartnersList(props) {
  const { partners } = props;

  const [localState, setLocalState] = useState({
    filter: {
      text: "",
    },
    sort: ["_metadata.start_date", "asc"],
    partners: [],
  });

  const filterPartners = () => {
    if (!partners) {
      return;
    }
    let filteredPartners = sortBy(
      partners.filter((partner) => {
        // text filtering
        if (localState.filter.text.length) {
          const text = localState.filter.text.toLowerCase();
          const fields = ["title"];
          for (let field of fields) {
            let val = get(partner, field);
            if (
              typeof val === "string" &&
              val.toLowerCase().indexOf(text) > -1
            ) {
              return true;
            }
          }
          return false;
        }
        return true;
      }),
      (item) => {
        let res = get(item, localState.sort[0]);
        //   console.log("res:", res, localState.sort[0]);
        return res;
      }
    );
    if (localState.sort[1] === "asc") {
      filteredPartners.reverse();
    }

    setLocalState((s) => ({ ...s, partners: filteredPartners }));
  };

  useEffect(filterPartners, [partners]);
  useDebounce(filterPartners, 250, [
    JSON.stringify([localState.sort, localState.filter]),
  ]);

  return (
    <div>
      <Grid container spacing={3}>
        <Grid item style={{ flex: 1 }}>
          <h1 className="title is-6">
            Filter Partners By Category/Tag: &nbsp;
            {/* <a className="tag is-size-7 is-pulled-right" v-if="tagFilters.length"
							v-on:click.prevent="clearTags">
							Clear Filters
							<button className="delete"></button>
						</a> */}
          </h1>
          <div className="buttons tag-buttons">
            {/* {{#each tags as | tag |}}
						{{#if tag.count}}
						<div className="button is-outlined is-small is-rounded is-custom-{{snakecase (lowercase (trim tag.tag))}}"
							:class='{"is-active": tagFilters.indexOf({{{ jsonstringify tag.tag }}}) > -1}'
							v-on:click='toggleFilterTag({{{ jsonstringify tag.tag }}})'
							:disabled="!remainingCount('{{{tag.tag}}}')">
							{{tag.tag}} <span style="width:28px;">(\{{remainingCount("{{{tag.tag}}}")}})</span>
						</div>
						{{/if}}
						{{/each}} */}
          </div>
        </Grid>
      </Grid>

      {partners.map((partner) => {
        console.log("partner:", partner);
        return (
          // <template v-if='tagsAllIncluded({{{ jsonstringify partner.data.tags }}})'>
          <div key={partner.id}>
            <hr />

            <Grid
              container
              spacing={3}
              // :className="{'is-active': showHides.indexOf({{ partner.id }}) > -1}"
            >
              <Grid item md={3}>
                {/* <img src="{{../common.env.IMGIX_PREFIX}}{{partner.Logo.s3key}}?w=200"> */}
                {partner.Logo ? (
                  <Imgix
                    src={`https://bigsurf1public.imgix.net/${partner.Logo?.s3key}`}
                    width={200}
                  />
                ) : null}
              </Grid>
              <Grid style={{ flex: 1 }}>
                <div className="columns">
                  <div className="column">
                    <h3
                      className="title is-5"
                      // style="padding-top:0px;cursor:pointer;"
                      // v-on: click="toggleShowHide({{ partner.id }})"
                    >
                      <span>{partner.name}</span>

                      <span>&nbsp; &nbsp; &nbsp;</span>
                    </h3>
                    <div className="tags">
                      {/* {{#each partner.data.tags}}
									<span className="tag is-small is-custom-{{snakecase (lowercase (trim this))}}">
										{{this}}
									</span>
									{{/each}} */}
                    </div>

                    <div className="content-IGNORE">
                      {partner.data.descriptionDisplay}
                    </div>
                  </div>
                  <div className="column">
                    <div
                    // style="cursor:pointer;"
                    // v-on: click="toggleShowHide({{ partner.id }})"
                    >
                      <div className="content-IGNORE">
                        {/* {{{partner.data.shortDisplay}}} */}
                      </div>

                      {/* {{#if partner.data.hasPartnerDiscount}}
									<div>
										<span className="icon has-text-success">
											<i className="far fa-money-bill-alt"></i>
										</span>
										<span>
											$20 Off Surfing w/ Receipt
										</span>
									</div>
									{{/if}} */}

                      <small
                      // style="cursor:pointer;text-decoration:underline;font-size:11px;"
                      >
                        view details
                      </small>
                      <br />
                      <br />

                      <p>
                        <a
                          href="{{{externalLink partner.data.url}}}"
                          target="_blank"
                        >
                          {partner.data.url}
                        </a>
                      </p>
                    </div>
                  </div>
                </div>

                <div v-show="showHides.indexOf({{partner.id}}) > -1">
                  <div className="box">
                    <div className="content">{partner.data.longDisplay}</div>

                    {/* {{#if partner.howToClaim}}
								<div>
									<h3 className="title is-5">
										How to Claim/Use:
									</h3>
									{{#markdown}}{{{partner.howToClaim}}}{{/markdown}}
									<br />
									<p>
										<strong>
											$20 Off Surfing w/ Receipt
										</strong>
										<br />
										To claim the $20 discount on your surf partner, show Big Surf Adventures your
										receipt from this
										business!
									</p>
								</div>
								{{/if}} */}
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>
        );
      })}
    </div>
  );

  return (
    <div>
      <div>
        <Grid container>
          <Grid item md={4} xs={12}>
            <TextField
              value={localState.filter.text}
              onChange={(e) =>
                setLocalState((s) => ({
                  ...s,
                  filter: { ...s.filter, text: e.target.value },
                }))
              }
              placeholder="Search"
              fullWidth
              margin="dense"
              size="small"
            />
          </Grid>
        </Grid>
      </div>
      {isLoading && !localState.partners?.length ? (
        <div style={{ textAlign: "center" }}>
          <CircularProgress size={30} />
        </div>
      ) : (
        <div>
          <TableContainer>
            <Table size="small" stickyHeader>
              <TableHead>
                <TableRow>
                  {/* Test/Charges / Canceled */}
                  <TableCell component="th"></TableCell>
                  <TableCell component="th" style={{ fontWeight: 600 }}>
                    Ready
                  </TableCell>
                  <TableCell component="th" style={{ fontWeight: 600 }}>
                    Done
                  </TableCell>
                  <TableCell
                    component="th"
                    style={{ fontWeight: 600 }}
                  ></TableCell>
                  <TableCell component="th" style={{ fontWeight: 600 }}>
                    Title
                  </TableCell>
                  <TableCell component="th" style={{ fontWeight: 600 }}>
                    People
                  </TableCell>
                  <TableCell component="th" style={{ fontWeight: 600 }}>
                    <TableSortLabel
                      active={localState.sort[0] === "_metadata.start_date"}
                      direction={localState.sort[1]}
                      onClick={() => {
                        if (localState.sort[0] === "_metadata.start_date") {
                          setLocalState((s) => ({
                            ...s,
                            sort: [
                              localState.sort[0],
                              localState.sort[1] === "asc" ? "desc" : "asc",
                            ],
                          }));
                        } else {
                          setLocalState((s) => ({
                            ...s,
                            sort: ["_metadata.start_date", localState.sort[1]],
                          }));
                        }
                      }}
                    >
                      Partner Date
                    </TableSortLabel>
                  </TableCell>
                  <TableCell component="th" style={{ fontWeight: 600 }}>
                    Created
                  </TableCell>
                  <TableCell component="th" style={{ fontWeight: 600 }}>
                    Updated
                  </TableCell>
                  {/* <TableCell component="th" style={{fontWeight: 600}}>New Media</TableCell> */}
                  <TableCell component="th" style={{ fontWeight: 600 }}>
                    Promo
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {localState.partners.map((partner) => (
                  <PartnerRow key={partner.id} partner={partner} />
                ))}
                {!localState.partners.length ? (
                  <TableRow>
                    <TableCell>No Results</TableCell>
                  </TableRow>
                ) : null}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      )}
    </div>
  );
}

const PartnerRow = ({ partner }) => {
  return (
    <TableRow>
      <TableCell>
        {partner.charges?.find((charge) => !charge.livemode) ? (
          <Chip label={"TEST"} color="secondary" size="small" />
        ) : null}
        {partner._metadata.canceled ? (
          <Chip label={"Canceled"} color="error" size="small" />
        ) : null}
      </TableCell>
      <TableCell>
        <Checkbox color="primary" checked={partner._metadata.ready} />
      </TableCell>
      <TableCell>
        <Checkbox color="primary" checked={partner._metadata.complete} />
      </TableCell>
      <TableCell>
        {/* Type of Partner */}
        {partner._metadata.main ? partner._metadata.main : "surf"}
      </TableCell>
      <TableCell>
        <div style={{ whiteSpace: "nowrap" }}>
          <a href={`/admin/partners/view/${partner.id}`}>
            {partner.title?.length ? partner.title : "missing title"}
          </a>
        </div>
      </TableCell>
      <TableCell>{partner._metadata.name}</TableCell>
      <TableCell>
        <div style={{ whiteSpace: "nowrap" }}></div>
      </TableCell>
      <TableCell>
        <div style={{ whiteSpace: "nowrap" }}>
          {moment(partner.createdAt).fromNow()}
        </div>
      </TableCell>
      <TableCell>
        <div style={{ whiteSpace: "nowrap" }}>
          {moment(partner.updatedAt).fromNow()}
        </div>
      </TableCell>
      {/* Count of new media */}
      {/* <TableCell></TableCell> */}
      <TableCell>{partner._metadata.promo_code}</TableCell>
    </TableRow>
  );
};
